"use client";

import { ErrorView } from "@/components/errors/ErrorView";

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <ErrorView boundary="RootErrorBoundary" error={error} reset={reset} />;
}
